import { FormAnswer } from "./FormAnswer";


export class FileAnswer
{
  constructor() {
    this.fileData = new Array<any>();
  }

  fileAnswerId: number;
  questionId: number;
  questionText: string;
  fileData: any[];
  fileName: string;
  contentType: string;
  type: string;
  order: number;
  formAnswer: FormAnswer;
	}
